import './index.css'
import React, { Component } from "react";
import { Avatar, Breadcrumb, Button, Col, FloatButton, Modal, Row, Switch, Typography, message } from "antd";
import { Link } from "react-router-dom";
import { IoAddOutline, IoArrowBack, IoLink, IoPencil, IoPersonCircle, IoTrash } from "react-icons/io5";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { POST_API, POST_CATCH, getToken, titleWeb } from "../../../services/hello-api";

class EventoTelao extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _navigate: false,
            _loading: true,
            _map: false,
            _map_data: [],
            _params: window.location.href.split('/'),
            _type: this.props.type === 'list' ? 'Lista' : 'Lixeira',
            data: [],
            filters: [],
            table_load: false,
            seconds: ''
        };
        this.back = this.props.url;
    }

    componentDidMount() {
        titleWeb('Projetos');
        this.onRenderData();
        this.initializeSeconds();
    }

    initializeSeconds = () => {
        const seconds = localStorage.getItem('telaoSeconds');
        if (seconds) {
            this.setState({ seconds });
        } else {
            localStorage.setItem('telaoSeconds', 10);
            this.setState({ seconds: 10 });
        }
    }

    onFilters = () => {
        POST_API('/event/filters.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({ filters: res.data });
            } else {
                message.error({ content: res.msg, key: 'screen' });
            }
        }).catch(() => POST_CATCH());
    }

    onRenderData = () => {
        setTimeout(async () => {
            POST_API('/timeline/search.php', { token: getToken(), filter: JSON.stringify({ EVENT_ID: this.state._params[6] }), type: this.props.type }).then(rs => rs.json()).then(res => {
                if (res.return) {
                    this.setState({ data: res.data });
                } else {
                    message.error({ content: res.msg, key: 'screen' });
                }
            }).catch(() => POST_CATCH()).finally(() => this.setState({ table_load: false }));
        }, 500);
    }

    onChangeType = (item, valor) => {
        POST_API('/timeline/update.php', { token: getToken(), ID: item.ID, VALOR: valor }).then(rs => rs.json()).then(res => {
            if (!res.return) {
                message.error({ content: res.msg, key: 'screen' });
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({ table_load: false }));
    }

    Card = ({ v }) => {
        return (
            <div className='Card'>
                <div className='img-container'><img src={v.PHOTO} alt='Evento' /></div>
                <div className='switch'><Switch checkedChildren="Exibindo" unCheckedChildren="Oculto" defaultChecked={v.TELAO === 'S'} onChange={(valor) => this.onChangeType(v, valor)} /></div>
                <div className='person-data'>
                    {v.AVATAR ? <Avatar src={v.AVATAR} /> : <IoPersonCircle className="no-avatar" />}
                    <Typography style={{ fontWeight: 600, marginLeft: 8 }}>{v.NICK ? v.NICK : v.NAME}</Typography>
                </div>
            </div>
        );
    }

    saveSeconds = (event) => {
        const seconds = event.target.value;
        localStorage.setItem('telaoSeconds', seconds);
        this.setState({ seconds });
    }

    SecondsTela = () => {
        return (
            <div className='seconds-tela'>
                <span>Segundos de tela:</span>
                <input type='number' value={this.state.seconds} onChange={this.saveSeconds} />
            </div>
        );
    }

    render() {
        const routes = this.props.bread;

        return (
            <Row className="Projetos-Telao">
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    <Link to={this.back}><FloatButton onClick={this.onChangePage} className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />} /></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8, 8]}>
                        <Col span={12}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <this.SecondsTela />
                            <Button onClick={() => { window.location.reload() }} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small" style={{ marginRight: 5 }}>Atualizar</Button>
                            <Link to={'/telao/' + this.state._params[6]}><Button onClick={this.onChangePage} type="default" size="small" shape="round" className="sys-btn-default sys-btn-small" style={{ marginRight: 5 }}>Exibir</Button></Link>
                            <Link to={this.back}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                    </Row>
                </Col>
                <div className="page-content">
                    {this.state.data && this.state.data.map((v, i) => v.PHOTO &&
                        <this.Card v={v} key={i} />
                    )}
                </div>
            </Row>
        );
    }
}

export default EventoTelao;
